// extracted by mini-css-extract-plugin
export default {"DropdownModal":"DropdownModal_DropdownModal__0ZQ0U"};